import { render, staticRenderFns } from "./lookup.vue?vue&type=template&id=a4dfb482&scoped=true&"
import script from "./lookup.vue?vue&type=script&lang=js&"
export * from "./lookup.vue?vue&type=script&lang=js&"
import style0 from "./lookup.vue?vue&type=style&index=0&id=a4dfb482&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dfb482",
  null
  
)

export default component.exports